export default __webpack_public_path__ + "static/media/chat4.f97fce79.svg";